import { render } from "./LicenseChangePropertyIdField.vue?vue&type=template&id=1db27ef3"
import script from "./LicenseChangePropertyIdField.vue?vue&type=script&lang=js"
export * from "./LicenseChangePropertyIdField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__